import { render, staticRenderFns } from "./SpinWheelPage.vue?vue&type=template&id=51ba5b5c&scoped=true&"
import script from "./SpinWheelPage.vue?vue&type=script&lang=js&"
export * from "./SpinWheelPage.vue?vue&type=script&lang=js&"
import style0 from "./SpinWheelPage.vue?vue&type=style&index=0&id=51ba5b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba5b5c",
  null
  
)

export default component.exports